module.exports = __webpack_public_path__ + "img/Pic_SSSKBB.a34646bb.png";